import React from "react";
import { Link } from "react-router-dom";
import "./Junkremovalheader.css";

export default function Junkremovalheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="junkremoval-hero"
      role="banner"
      aria-label="Junk Removal hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="junkremoval-hero__bg"
        src={`${base}/(232).webp`}
        alt="Team helping with junk removal services"
        loading="eager"
      />

      {/* Contrast overlay */}
      <div className="junkremoval-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="junkremoval-hero__content">
        <nav className="junkremoval-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="junkremoval-hero__breadcrumb-link">Home</Link>
          <span className="junkremoval-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="junkremoval-hero__breadcrumb-current">Junk Removal</span>
        </nav>

        <h1 className="junkremoval-hero__title">Junk Removal </h1>
        <p className="junkremoval-hero__subtitle">
          Fast, reliable, and eco-friendly junk removal to reclaim your space.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="junkremoval-hero__vignette" aria-hidden="true" />
      <div className="junkremoval-hero__grain" aria-hidden="true" />
    </section>
  );
}
